import React from "react";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import vi from "date-fns/locale/vi";
import {registerLocale} from "react-datepicker";
import BusTypeController from "../../../../services/system/bus/bus-type-controller";
import ModalEditConfigLate from "./modalEditConfigLate";
import ModalCreateConfigLate from "./modalCreateConfigLate";
import LatePickUpController from "../../../../services/system/late-pick-up/late-pick-up-controller";
import Utils from "../../../../utils/utils";
import ModalDeleteConfigLate from "./modalDeleteConfigLate";
registerLocale("vi", vi);
class ConfigLateManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",

            assistant1Id: "",
            assistant1Name: "",
            assistant1Username: "",

            driverId: "",
            driverName: "",
            driverUsername: "",

            state: "ACTIVE",
            listData: [],

            pageNumber: 0,
            pageSize: 10,
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "code",
                    name: "Mã cấu hình",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "time",
                    name: "Thời gian",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "price",
                    name: "Giá",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListLatePickUp()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListLatePickUp();
            }
        );
    };
    getListLatePickUp() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            state: this.state.state,
            sort: "created_at desc"
        };
        LatePickUpController.list(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onhandleSearch() {
        this.getListLatePickUp()
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Đang hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Đang khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        let {listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="config-late" parentClass="late-pick-up-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Cấu hình giá đón muộn"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <button
                                                    onClick={() => {
                                                        this.setState({showModalCreate: true})
                                                    }}
                                                    style={{height: 35, marginRight: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                >
                                                    Thêm mới
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "left"
                                                 }}>
                                                <label className="label-item col-12"><b>Lưu ý:</b> Cấu hình đã được áp dụng thì không xóa được</label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                        let a = "";
                                                        let descend = "";
                                                        if (data.sortAsc == null) {
                                                            // a = "id=asc";
                                                            a = "id";
                                                            descend = 'DESC'
                                                        } else {
                                                            a = data.sortId;
                                                            descend = data.sortAsc ? 'ASC' : 'DESC'
                                                        }
                                                        this.setState(
                                                            {
                                                                sort: a,
                                                                descending: descend
                                                            },
                                                            () => this.getListLatePickUp()
                                                        );
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {row.code}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                Từ {row.startHour}:{row.startMinute<10?"0"+row.startMinute:row.startMinute} - {row.endHour}:{row.endMinute<10?"0"+row.endMinute:row.endMinute}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.price)} đ
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.state=="INACTIVE" ? <span className="badge badge-danger" style={{color: "white"}}>Không hoạt động</span> : row.state=="ACTIVE" ?<span className="badge badge-success" style={{color: "white"}}>Hoạt động</span> : <span className="badge badge-warning" style={{color: "white"}}>Khóa</span>}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <button className="btn btn-action p-2"
                                                                        title='Sửa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalEdit: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-pencil-alt"/>
                                                                </button>
                                                                <button className="btn btn-action p-2"
                                                                        title='Xóa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalDelete: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-trash"/>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ModalEditConfigLate
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
                <ModalCreateConfigLate
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
                <ModalDeleteConfigLate
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default ConfigLateManagement;
